import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import cx from 'classnames';
import Modal from '../Modal';
import Button from '../Button';

export const NotificationModal = ({
  isFirstModalConfirmed,
  setOnFirstModalConfirmed,
  openSecondDialog,
  sendMessageAndAttachmentsTogether,
  isPdfConvertedToLink,
  hasTwoButtons,
  classes,
  isOpen,
  title,
  body,
  onClose,
  closeButton,
  hasCenterCloseButton,
  removeAttachments,
  imageSource,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeButton={closeButton}>
      {title && (
        <Typography variant="body1" className={classes.title}>
          {title}
        </Typography>
      )}
      <Typography variant="body1" className={cx(classes.textBody, isFirstModalConfirmed && classes.redInfo)}>
        {body}
      </Typography>
      {hasCenterCloseButton && (
        <Button onClick={onClose} className={classes.button}>
          Close
        </Button>
      )}
      {hasTwoButtons && (
        <Box display="flex" padding={1} data-testid="box">
          {!isFirstModalConfirmed && (
            <>
              <Button
                onClick={() => {
                  setOnFirstModalConfirmed(true);
                  openSecondDialog();
                }}
                className={classes.limitButton}
              >
                Confirm
              </Button>
              <Button
                onClick={() => {
                  const { id } = imageSource?.find(({ item }) => item?.isPDFSizeLimitExceeded);
                  removeAttachments(id);
                  onClose();
                }}
                className={classes.limitButton}
              >
                Cancel
              </Button>
            </>
          )}
          {isFirstModalConfirmed && (
            <Button
              onClick={() => {
                // eslint-disable-next-line no-param-reassign
                isPdfConvertedToLink.current = true;
                setOnFirstModalConfirmed(false);
                sendMessageAndAttachmentsTogether();
                onClose();
              }}
            >
              Confirm
            </Button>
          )}
        </Box>
      )}
    </Modal>
  );
};

NotificationModal.propTypes = {
  classes: PropTypes.shape({}),
  isPdfConvertedToLink: PropTypes.shape({}),
  title: PropTypes.string,
  body: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isFirstModalConfirmed: PropTypes.bool,
  hasTwoButtons: PropTypes.bool,
  setOnFirstModalConfirmed: PropTypes.func,
  openSecondDialog: PropTypes.func,
  sendMessageAndAttachmentsTogether: PropTypes.func,
  closeButton: PropTypes.oneOf(['left', 'right']),
  hasCenterCloseButton: PropTypes.bool,
};

NotificationModal.defaultProps = {
  classes: {},
  closeButton: 'left',
};

export default NotificationModal;
